import "../../style/InvoicePage.css";

const BusinessDetails = ({ socialWebsite, email, phone, customContent, isDesktopOrLaptop }) => {
  // Don't render anything if no business details provided
  if (!socialWebsite && !email && !phone && !customContent) {
    return null;
  }

  return (
    <>
      {isDesktopOrLaptop ? (
        // Desktop layout - horizontal with separator lines
        <>
          <span className="invoice-business-details invoice-business-details-text">
            {socialWebsite && (
              <>
                <a
                  href={
                    socialWebsite.startsWith("http://") || socialWebsite.startsWith("https://")
                      ? socialWebsite
                      : `https://${socialWebsite}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {socialWebsite}
                </a>
                {(email || phone) && <span className="invoice-business-information">|</span>}
              </>
            )}

            {email && (
              <>
                <span className="underline-text">{email}</span>
                {phone && <span className="invoice-business-information">|</span>}
              </>
            )}

            {phone && <span>{phone}</span>}
          </span>

          {customContent && <div className="invoice-business-details-text">{customContent}</div>}
        </>
      ) : (
        // Mobile layout - stacked vertically
        <div className="invoice-business-details invoice-business-details-text">
          {socialWebsite && (
            <div className="invoice-business-detail-item">
              <a
                href={
                  socialWebsite.startsWith("http://") || socialWebsite.startsWith("https://")
                    ? socialWebsite
                    : `https://${socialWebsite}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {socialWebsite}
              </a>
            </div>
          )}

          {email && (
            <div className="invoice-business-detail-item">
              <span className="underline-text">{email}</span>
            </div>
          )}

          {phone && (
            <div className="invoice-business-detail-item">
              <span>{phone}</span>
            </div>
          )}

          {customContent && <div className="invoice-business-detail-item">{customContent}</div>}
        </div>
      )}
    </>
  );
};

export default BusinessDetails;
